import {
  releaseSpacer,
  hasLiveInlineSpacer,
  inlineSpacerScroller,
  parkSpacer,
} from './inlineKeyboardSpacer';

/**
 * Restore policy for the inline keyboard guard (KAN-930, RD-DEV-025) —
 * extracted from `inlineKeyboardGuard.js` to keep it under the 500-line cap.
 *
 * Drawers and full-screen flows are "scroll once, stay": the guard scrolls a
 * field into view and never scrolls it back or drops the spacer when the
 * keyboard closes (the host's unmount releases it, PARKED until then).
 * Everything unmarked (pages, bottom sheets) keeps today's glide-back restore.
 */
export const SCROLL_STAYS_SELECTOR = '[data-cvx-kb-scroll-stays]';
/** KAN-930: rest pop-ups (Option B) carry this on their panel (`useModalTypingRest`). */
export const KB_REST_SELECTOR = '[data-cvx-kb-rest]';
/**
 * KAN-930: set on a body scroller by `modalBodyShrink` while ITS shrink is
 * active. Only such a scroller refuses the guard's spacer — a rest card whose
 * shrink failed falls back to today's spacer path.
 */
export const KB_SHRUNK_ATTR = 'data-cvx-kb-shrunk';

/** 'stay' | 'restore' for a scroller. */
export function restorePolicy(scroller) {
  return scroller && typeof scroller.closest === 'function' && scroller.closest(SCROLL_STAYS_SELECTOR)
    ? 'stay'
    : 'restore';
}

/** True while `scroller`'s body shrink is active (it needs no spacer). */
export function isShrunkScroller(scroller) {
  return !!(scroller && typeof scroller.hasAttribute === 'function' && scroller.hasAttribute(KB_SHRUNK_ATTR));
}

/**
 * The live spacer sits on a stay scroller → PARK it (padding kept until the
 * host unmounts). Returns true when parked.
 */
export function parkLiveSpacerIfStays() {
  if (hasLiveInlineSpacer() && restorePolicy(inlineSpacerScroller()) === 'stay') {
    parkSpacer();
    return true;
  }
  return false;
}

/** A live spacer on a scroller other than `current`: park it (stay) or release it. */
export function dropForeignSpacer(current) {
  if (!hasLiveInlineSpacer() || inlineSpacerScroller() === current) return;
  // A stay scroller (a drawer under a pop-up) keeps its space, parked.
  if (!parkLiveSpacerIfStays()) releaseSpacer();
}
